import ProHeader1Editor from './components/ProHeader1Editor';
import ProHeader1View from './components/ProHeader1View';
import ProAddress from './components/ProAddress';
import ProAddressEditor from './components/ProAddressEditor';
import ProAddressRow from './components/ProAddressRow';
import ProContact from './components/ProContact';
import ProContactEditor from './components/ProContactEditor';
import ProContactRow from './components/ProContactRow';
import ProfileTermsView from "./components/ProfileTermsView";
import ProfileTermsEditor from "./components/ProfileTermsEditor";
import ProfileBank from "./components/ProfileBank";
import ProfileBankEditor from "./components/ProfileBankEditor";
import ProfileShorthand from "./components/ProfileShorthand";
import ProfileShorthandMain from "./components/ProfileShorthandMain";

import ProfileIdentity from "./components/ProfileIdentity";
import ProfileIdentityRow from "./components/ProfileIdentityRow";
import ProfileIdentityEditor from "./components/ProfileIdentityEditor";

import ProfileMem from "./components/ProfileMem";
import ProfileMemEditor from "./components/ProfileMemEditor";
import ProfileMemRow from "./components/ProfileMemRow";
import ProfileTrackHeader from "./components/ProfileTrackHeader";

import ProfileCharge from './components/ProfileCharge';
import ProfileChargeRow from './components/ProfileChargeRow';

import CategoryMasterSH from '../system/category/components/CategoryMasterSH';
import CategoryDetailSH from '../system/category/components/CategoryDetailSH';

import ProQV from './components/ProQV';
import cmnViewMap from '../cmn/Index';
import systemViewMap from '../system/Index';
import DocItem from '../cmn/DocItem';

const profileViewMap = {
    "vProHeaderViewer": ProHeader1View,
    "vProHeaderEditor": ProHeader1Editor,
    "vProAddress":ProAddress,
    "vProAddressEditor":ProAddressEditor,
    "vProAddressRow":ProAddressRow,
    "vProContact":ProContact,
    "vProContactEditor":ProContactEditor,
    "vProContactRow":ProContactRow,
    "vProQV":ProQV,
    "vProTermsEditor":ProfileTermsEditor,
    "vProTermsViewer":ProfileTermsView,
    "vProBank":ProfileBank,
    "vProBankEditor":ProfileBankEditor,
    
    "vCatMasterSH": CategoryMasterSH,
    "vCatDetailSH": CategoryDetailSH,
    "vProShorthand":ProfileShorthand,
    "vProfileShorthandMain":ProfileShorthandMain,

    "vProId":ProfileIdentity,
    "vProIdRow":ProfileIdentityRow,
    "vProIdEditor":ProfileIdentityEditor,

    "vProMem":ProfileMem,
    "vProMemRow":ProfileMemRow,
    "vProMemEditor":ProfileMemEditor,
    "vProTrackHeader": ProfileTrackHeader,

    "vProCharge":ProfileCharge,
    "vProChargeRow":ProfileChargeRow,
    "vProChargeEditor":ProfileChargeRow,

    "vDocItem":DocItem,

    ...cmnViewMap,
    ...systemViewMap
}

export default profileViewMap;